import React, { useEffect, useState } from 'react'
import axios from '../../../utils/axiosConfig';
import Swal from 'sweetalert2';
import { MDBCol, MDBRow } from 'mdb-react-ui-kit';
import { EyeClosedIcon, EyeOpenIcon } from '@radix-ui/react-icons';

const FormModalCreateDispositivo = ({ onSave, initialData, operators, proyectos }) => {

    const [DeviceID, setDeviceID] = useState(initialData?.DeviceID || '');
    const [fkLokCommOp, setFkLokCommOp] = useState(
        initialData?.fkLokCommOp != null ? String(initialData.fkLokCommOp) : ''
    );
    const [fkLokProyecto, setFkLokProyecto] = useState(
        initialData?.fKLokProyecto != null ? String(initialData.fKLokProyecto) : ''
    );

    const [username, setUsername] = useState(initialData?.username || '');
    const [password, setPassword] = useState(initialData?.password || '');

    const [showPassword, setShowPassword] = useState(false);



    const submit = e => {
        e.preventDefault()
        if (!DeviceID.trim() || !fkLokCommOp.trim() || !fkLokProyecto.trim()) {
            Swal.fire('Error', 'Debe completar todos los campos', 'error')
            return
        }
        console.log('Dispositivo creado:', { DeviceID, fkLokCommOp, fkLokProyecto, username, password });
        onSave({ DeviceID, fkLokCommOp, fkLokProyecto, username, password });
    }



    return (
        <>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Device ID</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Ingrese Device ID"
                        value={DeviceID}
                        maxLength={50}
                        onChange={e => { setDeviceID(e.target.value) }}
                        style={{ boxSizing: 'border-box' }}
                        disabled={initialData?.ID !== -1}
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Username</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Ingrese Username"
                        value={username}
                        maxLength={50}
                        onChange={e => { setUsername(e.target.value) }}
                        style={{ boxSizing: 'border-box' }}

                    />
                </MDBCol>
            </MDBRow>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Password</label>
                    <div className="input-group">
                        <input
                            type={showPassword ? "text" : "password"}
                            className="form-control"
                            placeholder="Ingrese Password"
                            value={password}
                            maxLength={50}
                            onChange={e => { setPassword(e.target.value) }}
                            style={{ boxSizing: 'border-box' }}
                        />
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? <EyeClosedIcon /> : <EyeOpenIcon />}
                        </button>
                    </div>
                </MDBCol>
            </MDBRow>


            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Operador</label>
                    <select
                        className="form-control"
                        value={fkLokCommOp}
                        onChange={e => { setFkLokCommOp(e.target.value) }}
                        style={{ boxSizing: 'border-box' }}
                    >
                        <option value="">Seleccione un operador</option>
                        {operators.map(op => (
                            <option key={op.IdOperadorGPS} value={op.IdOperadorGPS}>{op.OperadorGPS}</option>
                        ))}
                    </select>
                </MDBCol>
            </MDBRow>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Proyecto</label>
                    <select
                        className="form-control"
                        value={fkLokProyecto}
                        onChange={e => { setFkLokProyecto(e.target.value) }}
                        style={{ boxSizing: 'border-box' }}
                        disabled={initialData?.ID !== -1}
                    >
                        <option value="">Seleccione un proyecto</option>
                        {proyectos.map(proj => (
                            <option key={proj.IDProyecto} value={proj.IDProyecto}>{proj.Descripcion}</option>
                        ))}
                    </select>
                </MDBCol>
            </MDBRow>

            <div className="d-flex justify-content-end">
                <button className='btn-primary-modals-maestros' onClick={submit}>
                    {initialData?.ID !== -1 ? 'Actualizar' : 'Guardar'}
                </button>
            </div>
        </>
    )
}

export default FormModalCreateDispositivo
